import React, { Suspense } from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { AuthRoute } from "./auth.routes";

const Login = React.lazy(() => import("../screens/Login"));
const TabelaPrecos = React.lazy(() => import("../screens/TabelaPrecos"));
const ListaGerada = React.lazy(() => import("../screens/ListaGerada"));
const TabelaCliente = React.lazy(() => import("../screens/TabelaCliente"));
const PDF = React.lazy(() => import("../screens/PDF"));
const TMKT = React.lazy(() => import("../screens/TMKT"));
const DetalhesTMKT = React.lazy(() => import("../screens/DetalhesTMKT"));
const Clientes = React.lazy(() => import("../screens/Clientes"));
const DetalhesDeCliente = React.lazy(
  () => import("../screens/DetalhesDeCliente")
);

const Routes: React.FC = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<></>}>
        <Switch>
          <Route path="/login" exact component={Login} />

          <Route path="/pdf/:uuid" component={PDF} />
          <Route path="/tabelapreco/cliente/:uuid" component={TabelaCliente} />

          <AuthRoute
            path="/clientes/detalhes/:id"
            component={DetalhesDeCliente}
          />

          <AuthRoute path="/tabelapreco" component={TabelaPrecos} />
          <AuthRoute path="/listagerada" component={ListaGerada} />

          <AuthRoute path="/tmkts/detalhes/:id" component={DetalhesTMKT} />
          <AuthRoute path="/tmkts" component={TMKT} />

          <AuthRoute path="/clientes" component={Clientes} />

          <Route path="*" render={() => <Redirect to="/login" />} />
        </Switch>
      </Suspense>
    </BrowserRouter>
  );
};

export default Routes;
